import { Injectable } from '@angular/core';
import { interval, Subject, Subscription } from 'rxjs';
import { take, timeout } from 'rxjs/operators';
import { HttpService } from './http.service';
import creditCardType from "credit-card-type";

// declare var $gn: any;
declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class GerencianetService {

  submitingCardBrand: boolean = false;
  private submitCartSubscription: Subscription;

  constructor(
    private http: HttpService
  ) {

  }

  getCardBrand(cardNumber: string, subject: Subject<any>) {

    this.submitingCardBrand = true;

    const [card] = creditCardType(cardNumber);

    if (card) {
      const name = card.type;
      subject.next(name);
    } else subject.next(false);
    this.submitingCardBrand = false;

  }

  connectPayment(data, subject: Subject<any>) {

    const expirationMonth = data.expirationDate.substr(0, 2);
    const expirationYear = data.expirationDate.substr(2);
    subject.next(true);

    window.gerencianet.checkout.getPaymentToken(
      {
        brand: data.brandCard,
        number: data.cardNumber,
        cvv: data.cvv,
        expiration_month: expirationMonth,
        expiration_year: expirationYear
      },
      (error, response) => {

        if (error) {
          subject.error(error);
          return;
        }

        const user = JSON.parse(localStorage.getItem('token'));
        const { data: { payment_token } } = response;
        this.http.save('gerencianet:alter_payment', {
          ...data,
          userId: user.id,
          cardToken: payment_token,
        }).subscribe(
          (result: any) => {

            if (result.type === 'OK')
              subject.next(result);
            else subject.error(result)

          },
          err => {
            console.error('ERR', err);
            subject.error(false)
          }
        );

      }
    );

  }

  unsubscribe() {

    if (this.submitCartSubscription)
      this.submitCartSubscription.unsubscribe();

  }

  tryPayment(data: any, submitSubject: Subject<any>) {

    this.connectPayment(data, submitSubject);

  }

  tryPaymentBillet(data: any, subject: Subject<any>) {

    const user = JSON.parse(localStorage.getItem('token'));

    const combinedData = {
      ...data.step1,
      ...data.step2,
      userId: user.company_id,
      signaturePlanId: data.signaturePlanId
    };

    this.http.save('gerencianet:payment_billet', 
      combinedData
    ).subscribe(
      (result: any) => {

        // console.log('RESULT', result)

        if (result.type === 'OK')
          subject.next(result);
        else subject.error(result)

      },
      err => {
        console.error('ERR', err);
        subject.error(false)
      }
    );

  }

}